import type {MessageItem} from "./MessageItem.js";
import {MessageFactory} from "../factory/MessageFactory.js";

export class SessionItem {

    private _sessionId: string
    private _sessionTitle: string
    private _msgList: MessageItem[] = []
    private _lastMessage: MessageItem

    constructor(sessionId: string, sessionTitle: string = "新規会話") {

        this._sessionId = sessionId
        this._sessionTitle = sessionTitle
        this._lastMessage = MessageFactory.createDefaultMsg()
        this.pushMessage(this._lastMessage)

    }

    public pushMessage(message: MessageItem) {
        this._lastMessage = message
        this._msgList.push(message)
    }


    get sessionId(): string {
        return this._sessionId;
    }

    get msgList(): MessageItem[] {
        return this._msgList;
    }

    get lastMessage(): MessageItem {
        return this._lastMessage;
    }

    set sessionTitle(value: string) {
        this._sessionTitle = value;
    }

    get sessionTitle(): string {
        return this._sessionTitle;
    }
}